<!-- =========================================================================================
	File Name: Login.vue
	Description: Login Page
	----------------------------------------------------------------------------------------
========================================================================================== -->

<template>
  <div class="h-screen flex w-full bg-img">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 mx-auto self-center login-page">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
              <!-- <img src="@/assets/images/pages/register.png" alt="login" class="mx-auto"> -->
              <img
                src="@/assets/images/logo/logo.png"
                alt="login"
                style="max-width: 240px;"
                class="mx-auto page-logo"
              />
              <img
                src="@/assets/images/pages/banner-img.svg"
                alt="login"
                class="mx-auto page-image"
                style="max-width: 350px;"
              />
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center">
              <div class="p-8 bg-white log-in">
                <div>
                  <div class="vx-card__title mb-8">
                    <h2 class="mb-4">Login</h2>
                    <p>Please login to your account</p>
                  </div>
                  <div>
                    <vs-input
                      icon="icon icon-user"
                      v-validate="'required|email'"
                      name="email"
                      icon-pack="feather"
                      label-placeholder="Email"
                      v-model="email"
                      class="w-full"
                      autocomplete="off"
                      @keyup.enter="login()"
                    />
                    <span class="text-danger text-sm">{{ errors.first('email') }}</span>
                  </div>
                  <div>
                    <vs-input
                      type="password"
                      icon="icon icon-lock"
                      v-validate="'required'"
                      name="password"
                      icon-pack="feather"
                      label-placeholder="Password"
                      v-model="password"
                      class="w-full"
                      autocomplete="off"
                      @keyup.enter="login()"
                    />
                    <span class="text-danger text-sm">{{ errors.first('password') }}</span>
                  </div>
                  <!-- <div>
                    <vs-select
                      autocomplete
                      class="w-full no-icon-border pt-8"
                      v-validate="'required'"
                      placeholder="User Role"
                      name="role"
                      v-model="role"
                    >
                     
                      <vs-select-item
                        :key="index"
                        :value="item.value"
                        :text="item.text"
                        v-for="(item,index) in role_list"
                      />
                    </vs-select>
                    <span class="text-danger text-sm">{{ errors.first('role') }}</span>
                  </div>-->
                  <vs-button
                    class="float-right mt-6"
                    id="user-login"
                    :disabled="button_loading"
                    @click="login()"
                  >Login</vs-button>
                </div>
                <vs-divider position="center" class="my-8"></vs-divider>
                <a
                  class="float-right cursor-pointer"
                  @click.prevent="forgotPassword()"
                >Forgot Password?</a>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { Validator } from "vee-validate";
const dict = {
  custom: {
    email: {
      required: "Please enter email",
      email: "Please enter valid email"
    },
    password: {
      required: "Please enter password"
    }
  }
};
// register custom messages
Validator.localize("en", dict);
export default {
  data() {
    return {
      email: "",
      password: "",
      role: "",
      role_list: [
        {
          text: "Super Admin",
          value: "SA"
        },
        {
          text: "Company Admin",
          value: "CA"
        },
        {
          text: "HR Manager",
          value: "HR"
        },
        {
          text: "User",
          value: "U"
        }
      ]
    };
  },
  mounted() {
    if (localStorage.getItem("sio_email")) {
      this.email = localStorage.getItem("sio_email");
    }
  },
  methods: {
    login() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.button_loader(true, "#user-login");
          let input = {
            email: this.email,
            password: this.password
            // role : this.role,
          };
          this.axios
            .post("auth/login", input)
            .then(response => {
              let data = response.data.data;
              this.button_loader(false, "#user-login");
              let token = data.web_token;
              localStorage.setItem("authToken", token);
              this.$store.dispatch("updateAuthToken", token);
              if(data.is_first_time_login == true){
                
              }
              let uInfo = {
                id: data.id,
                firstname: data.firstname,
                lastname: data.lastname,
                email: data.email,
                role: data.roles,
                inOutStatus: data.inoutreference,
                card_details: data.card_details,
                payment_plan: data.payment_plan,
                is_plan_expire: data.is_plan_expire,
                timeZone: data.timeZone,
                stripe_plan_id: data.stripe_plan_id,
                organization: data.organization,
                org_name: data.org_name,
                org_image: data.org_image,
                profile_image: data.profile_image,
                phone: data.phone,
                designation: data.designation,
                qr_code: data.qr_code,
                office_id: data.office_details != null ? data.office_details.id : "",
                office_nm: data.office_details != null ? data.office_details.office_name: "",
                department_nm:
                  data.department_details != null
                    ? data.department_details.department_name
                    : "",
                balance: data.balance,
                expiry_date: data.expiry_date,
                user_id: data.user_id,
                is_disabled: data.is_disabled,
                is_first_time_login: data.is_first_time_login,
                is_owner:data.is_owner,
                is_profile_complete:data.is_first_time_login?false:true,
              };
              let liveStatus = data.inoutreference;
              localStorage.setItem("user", JSON.stringify(uInfo));
              this.$store.dispatch("updateUser", uInfo);
              
              this.$store.dispatch("updateLiveStatus", liveStatus);
              /** clear email in localstorage */
              // localStorage.removeItem("sio_email");

              // if (data.is_plan_expire == true && data.roles != 'SA') {
              //    this.$router.push({ name: "organizationSettings" });
              //    return
              // }
              if (data.roles === "SA") {
                this.$router.push({ name: "adminDashboard" });
              }
              if (data.roles === "CA" || data.roles === "HR") {
                if (uInfo.is_first_time_login || uInfo.is_plan_expire) {
                  this.$router.push({ name: "organizationSettings" });
                }else {
                  this.$router.push({ name: "organizationDashboard" });
                }
              }

              if (data.roles === "U") {
                this.$router.push({ name: "userDashboard" });
              }
            })
            .catch(e => {
              this.showError(e, "#user-login");
            });
        }
      });
    },
    forgotPassword() {
      this.$router.push({ name: "forgotPassword" });
    }
  }
};
</script>
<style>
.login-page .vs-divider-border {
  border: 0 !important;
}
.log-in {
  padding: 30px 25px !important;
  float: left;
  width: 100%;
}

.login-page {
  align-items: center;
  display: flex;
}
.page-logo {
  max-width: 240px;
}
.page-image {
  max-width: 350px;
}
</style>
